import React, { ReactNode } from 'react';

const tableStyle: React.CSSProperties = {
  borderCollapse: 'collapse',
  width: '100%',
};

const thStyle: React.CSSProperties = {
  padding: '0.5rem',
  fontWeight: 600,
  textAlign: 'left',
  borderBottom: '2px solid #ccc',
};

export const cellStyle: React.CSSProperties = {
  padding: '0.5rem',
};

export const rowStyle: React.CSSProperties = {
  borderBottom: '1px solid #e0e0e0',
};

export const headerCellStyle = thStyle;

export function WetagsTable({
  children,
  style,
}: {
  children: ReactNode;
  style?: React.CSSProperties;
}) {
  return <table style={{ ...tableStyle, ...style }}>{children}</table>;
}
